/* eslint-disable camelcase */

import { Select, IProps as SelectProps } from 'components/atoms/Select/Select.components';
import { useEffect } from 'react';
import { useGetPicklistQuery } from 'services/sap';
import { catalogoPersonal, catalogoLenguage } from 'utils/helpers/dictionaries';

interface CivilStatusSelectProps extends Omit<SelectProps, 'handleChange'> {
  handleChange: (value: { value: string; valueEn: string }) => void;
}

const allowedCivilStatus = ['Soltero/a', 'Casado/a', 'Cohabitación'];

export default function CivilStatusSelect({
  handleChange,
  ...rest
}: Readonly<CivilStatusSelectProps>) {
  const { data: civilStatus, isLoading } = useGetPicklistQuery<{
    data: {
      label_en_US: string;
      label_es_ES: string;
    }[];
    isLoading: boolean;
  }>({
    catalogName: catalogoPersonal.ecMaritalStatus,
    languages: catalogoLenguage.ESyUS,
  });

  const options = civilStatus
    ?.filter(({ label_es_ES }) => allowedCivilStatus.includes(label_es_ES))
    .map(({ label_es_ES }) => ({
      value: label_es_ES,
      label: label_es_ES,
    }));

  useEffect(() => {
    if (!civilStatus || isLoading || !rest.value) {
      return;
    }
    let selectedContract = civilStatus?.find(({ label_es_ES }) => label_es_ES === rest.value?.value);

    if (!selectedContract) {
      return;
    }

    handleChange({
      value: selectedContract?.label_es_ES ?? '',
      valueEn: selectedContract?.label_en_US ?? '',
    });
  }, [isLoading, civilStatus])

  return (
    <Select
      options={options}
      {...rest}
      handleChange={(value) => {
        let selectedContract;
        if (value) {
          selectedContract = civilStatus?.find(({ label_es_ES }) => label_es_ES === value);
        }
        return handleChange({
          value: value?.toString() ?? '',
          valueEn: selectedContract?.label_en_US ?? '',
        });
      }}
      disabled={isLoading}
    />
  );
}
